import _Box from "@mui/material/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import PointsRuleCard from './points-rule-card';
function BfgPointsRules() {
  const {
    t
  } = useTranslation();
  const points = [{
    emoji: '🚴',
    label: t('commons.challenges.bfg_faq.points_rules.distance_label'),
    value: t('commons.challenges.bfg_faq.points_rules.distance_value')
  }, {
    emoji: '🏠',
    label: t('commons.challenges.bfg_faq.points_rules.home_work_label'),
    value: t('commons.challenges.bfg_faq.points_rules.home_work_value')
  }, {
    emoji: '🗺️',
    label: t('commons.challenges.bfg_faq.points_rules.zone_label'),
    value: t('commons.challenges.bfg_faq.points_rules.zone_value')
  }];
  return /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    sx: {
      containerType: 'inline-size'
    }
  }, points.map(({
    emoji,
    label,
    value
  }) => /*#__PURE__*/React.createElement(PointsRuleCard, {
    emoji: emoji,
    key: label,
    label: label,
    value: value
  })));
}
export default BfgPointsRules;